const state = {
    companyData: [], // 公司新闻总数据
    groupData: [],//集团新闻
    industryData: [],//行业动态
    now: 'companyData'
}
const getters = {
    getnow: (state) => {
        return state.now
    },
    getnext: (state, getters) => (id) => {
        let n = ''
        let data = state[state.now]
        for (let i = 0; i < data.length; i++) {
            let item = data[i]
            if (item.id == id) {
                if (i + 1 == data.length) {
                    n = data[0].id
                } else {
                    n = data[i + 1].id
                }
            }
        }
        return n
    },
    getpre: (state) => (id) => {
        let n = ''
        let data = state[state.now]
        for (let i = 0; i < data.length; i++) {
            let item = data[i]
            if (item.id == id) {
                if (i == 0) {
                    n = data[data.length - 1].id
                } else {
                    n = data[i - 1].id
                }
            }
        }
        return n
    },
}
const mutations = {
    set_companyData(state, v) {
        state.companyData = v
    },
    set_groupData(state, v) {
        state.groupData = v
    },
    set_industryData(state, v) {
        state.industryData = v
    },
    set_now(state, v) {
        state.now = v
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/module/news.js